import { IoWarningOutline } from "react-icons/io5";
import Toaster from "../../../../components/common/Toaster";
import complianceService from "../../../../services/complianceService";

const CorFormsConfirmation = ({ data, onClose, onSuccess }) => {
  const handleDelete = async (item) => {
    try {
      onSuccess(item);
      await complianceService.deleteCORFormAsync(item.id);
      Toaster.Success("Tax Type Deleted Successfully");
    } catch (ex) {
      Toaster.Error("Something went wrong.");
    }
  };

  return (
    <div className="p-8">
      <div className="flex justify-center">
        <>
          <IoWarningOutline className="text-red-500 text-5xl" />
        </>
      </div>
      <p className="text-gray-400 text-sm text-center mt-7">
        Are you sure you want to delete <br />
        <span className="text-gray-500">
          {data && data.tax_type} - {data && data.tax_type_form}
        </span>
        ?
      </p>
      <div className="grid grid-cols-3 mt-8 space-x-2">
        <div className="col-span-1">
          <button
            className="text-gray-400 text-sm button outline-none float-right hover:text-blue-400"
            onClick={() => onClose()}
          >
            Cancel
          </button>
        </div>
        <div className="col-span-2">
          <button
            onClick={() => handleDelete(data)}
            className="button bg-red-500 text-white"
          >
            Yes, delete it.
          </button>
        </div>
      </div>
    </div>
  );
};

export default CorFormsConfirmation;
